// src/modules/app-views/leads/pages/Document/actions/menuButton.js

const leadsDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [],
  };
};

export default leadsDocumentMenuButton;
